(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog--heading-links"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    let query;
    const tagQuery = ' OR tag:';
    const searchField = document.getElementById('magazine-search-field');
    const searchQuery = document.getElementById('magazine-search-query');
    const searchParams = new URLSearchParams(window.location.search);

    for (const [key, value] of searchParams) {
      if (key === 'q') {
        const endIndex = value.indexOf(tagQuery);

        if (endIndex > -1) {
          query = value.slice(0, endIndex);
          const result_count = document.getElementById('magazine-search-results-count').value;

          searchField.value = query;
          document.getElementById('magazine-search-terms').innerText = `"${query}"`;
          window.analytics.track('Magazine Searched', {
            query,
            result_count,
          });
        }
      }
    }

    searchField.addEventListener('change', (e) => {
      const queryValue = e.currentTarget.value.trim();
      
      if (queryValue) searchQuery.value = `${queryValue}${tagQuery}${queryValue}`;
    });

    document.querySelectorAll('[magazine-article]').forEach((article) => {
      article.addEventListener('click', (e) => {
          const { dataset, id, href, title } = e.currentTarget;
          window.analytics.track('Article Clicked', {
            article_id: dataset.magazineArticleId,
            article_tags: dataset?.magazineArticleTags,
            article_title: title,
            article_url: href,
            query
          });
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-text-video-split"] && !Shopify.designMode) return;
  try {
    
  const script = document.createElement('script');
  script.src = 'https://player.vimeo.com/api/player.js';
  script.defer = true;

  script.addEventListener('load', () => {
    document.querySelectorAll('[data-vimeo-player]').forEach(({ id }) => {
      new Vimeo.Player(id, {
        id,
        responsive: true,
      });
    });
  });

  document.head.append(script);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-video-split"] && !Shopify.designMode) return;
  try {
    
  const script = document.createElement('script');
  script.src = 'https://player.vimeo.com/api/player.js';
  script.defer = true;

  script.addEventListener('load', () => {
    document.querySelectorAll('[data-vimeo-player]').forEach(({ id }) => {
      new Vimeo.Player(id, {
        id,
        responsive: true,
      });
    });
  });

  document.head.append(script);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-full-bleed"] && !Shopify.designMode) return;
  try {
    
  const script = document.createElement('script');
  script.src = 'https://player.vimeo.com/api/player.js';
  script.defer = true;

  script.addEventListener('load', () => {
    document.querySelectorAll('[data-vimeo-player]').forEach(({ dataset, id }) => {
      const autoplay = dataset.vimeoAutoplay === 'true';
      const loop = dataset.vimeoLoop === 'true';

      new Vimeo.Player(id, {
        autoplay,
        id,
        loop,
        muted: autoplay,
        responsive: true,
      });
    });
  });

  document.head.append(script);

  } catch(e) { console.error(e); }
})();
})();
